exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-1b5721c1],.fade-leave-active[data-v-1b5721c1]{transition:opacity .5s}.fade-enter[data-v-1b5721c1],.fade-leave-to[data-v-1b5721c1]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b5721c1","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/howwework.vue
// module id = 351
// module chunks = 0